import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { SelectComponentOptions } from '@app/shared/components/select/base-select-with-id.component';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { CaseParticipantUriBuilderParams } from '@app/core/services/participants.service';
import { WorkflowParticipantUriBuilderParams } from '@app/core/services/workflow/workflow-participants.service';
import { ParticipantTypeSelectComponent } from '@app/shared/components/select/participant-type-select/participant-type-select';

@Component({
  selector: 'new-participant',
  templateUrl: './new-participant.component.html',
  styleUrls: ['./new-participant.component.scss']
})
export class NewParticipantComponent extends BaseComponent implements OnInit {

  @ViewChild('participantTypeSelect')
  public participantTypeSelect: ParticipantTypeSelectComponent;

  @Input()
  public title: string;

  @Input()
  public panelOpen: boolean;

  @Input()
  public selectedType: string;

  @Input()
  public typeSelectOptions?: SelectComponentOptions;

  @Input()
  public excludedTypes: string[];

  @Input()
  public participantTypeUriBuilderParams: CaseParticipantUriBuilderParams | WorkflowParticipantUriBuilderParams;

  @Output()
  public panelOpenChange = new EventEmitter<boolean>();

  @Output()
  public create = new EventEmitter<string>();

  constructor() {
    super();
  }

  public ngOnInit() {
  }

  public closePanel(): void {
    this.panelOpenChange.emit(false);
  }

  public createParticipant(): void {
    this.create.emit(this.selectedType);
  }

  public resetTypeSelect(): void {
    this.selectedType = null;
    this.participantTypeSelect.ngOnInit();
  }
}
